/**
 * Get group list from domain
 *
 * @param {Object} params
 * @param {string} params.domain ej 'M_ODENIEL'
 * @returns group list / empty list
 */
export async function getGroupList(params = {}) {
  return fetch('/connect/getGroupList', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(params),
  })
    .then((response) => response.json())
    .catch((e) => {
      console.error('getGroupList', e);
      return [];
    });
}
